import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("g", null, [
                _createElementVNode("path", {
                  stroke: "#252729",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5",
                  d: "M9.057 7.084c.191-.798.522-1.5.992-2.107.469-.606 1.101-1.087 1.897-1.443C12.74 3.178 13.733 3 14.923 3c.402 0 .8.024 1.194.072.393.048.753.12 1.08.217l-.317 3.755c-.173-.057-.375-.105-.605-.144-.23-.038-.46-.058-.69-.058-.442 0-.797.078-1.066.231-.268.154-.478.361-.633.62-.262.44-.368 1.05-.403 1.845h3.354v3.739h-3.354v8.656H8.77v-8.656H7v-3.74h1.77c.03-1.499.287-2.453.287-2.453",
                  transform: "translate(-131 -68) translate(0 48) translate(0 12) translate(115) translate(16 8)"
                })
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }